var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplierWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66471 0.5V2.16667H12.6564L4.46471 10.3583L5.63971 11.5333L13.8314 3.34167V6.33333H15.498V0.5M13.8314 13.8333H2.16471V2.16667H7.99805V0.5H2.16471C1.23971 0.5 0.498047 1.25 0.498047 2.16667V13.8333C0.498047 14.2754 0.673642 14.6993 0.986202 15.0118C1.29876 15.3244 1.72269 15.5 2.16471 15.5H13.8314C14.2734 15.5 14.6973 15.3244 15.0099 15.0118C15.3225 14.6993 15.498 14.2754 15.498 13.8333V8H13.8314V13.8333Z",
    fill: "#0369A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierWebsite);
export default __webpack_public_path__ + "static/media/supplier-website.cda9899b89da8e4aa4fd146bd0adfe24.svg";
export { ForwardRef as ReactComponent };